// extracted by mini-css-extract-plugin
export default {"customAreaImage":"styles_customAreaImage__etWFG","image":"styles_image__nQhoa"};